import api from './api-config';

// New analytics functions
export const runAnalyticsQuery = async (queryData) => {
    try {
        const response = await api.post('/analytics/query', queryData);
        return response.data;
    } catch (error) {
        console.error('Error running analytics query:', error);
        throw error;
    }
};

// Get financial summary for a specified time period
export const getFinancialSummary = async (timeRange) => {
    try {
        // Make sure we're passing the timeRange as the time_range field
        const response = await api.post('/analytics/summary', {time_range: timeRange});
        return response.data;
    } catch (error) {
        console.error('Error fetching financial summary:', error);
        throw error;
    }
};


export const getRevenueByCategoryAnalytics = async (timeRange, includeChildTags = true) => {
    try {
        const params = {
            time_range: timeRange,
            aggregation: 'sum',
            group_by: ['tag'],
            filters: {
                transaction_types: ['revenue'],
                include_child_tags: includeChildTags
            }
        };

        const response = await api.post('/analytics/query', params);
        return response.data;
    } catch (error) {
        console.error('Error getting revenue by category:', error);
        throw error;
    }
};

export const getExpensesByCategoryAnalytics = async (timeRange, includeChildTags = true) => {
    try {
        const params = {
            time_range: timeRange,
            aggregation: 'sum',
            group_by: ['tag'],
            filters: {
                transaction_types: ['expense'],
                include_child_tags: includeChildTags
            }
        };

        const response = await api.post('/analytics/query', params);
        return response.data;
    } catch (error) {
        console.error('Error getting expenses by category:', error);
        throw error;
    }
};

export const getCashFlowAnalytics = async (timeRange) => {
    try {
        const params = {
            time_range: timeRange,
            aggregation: 'sum',
            group_by: ['month']
        };

        const response = await api.post('/analytics/query', params);
        return response.data;
    } catch (error) {
        console.error('Error getting cash flow analytics:', error);
        throw error;
    }
};

// Tag Drill-Down Analytics
export const getTagDrillDownData = async (tagType, timeRange, parentTagId = null) => {
    try {
        // Build query parameters
        const params = {
            tag_type: tagType,
            time_range: JSON.stringify(timeRange)
        };

        // Add parent_tag_id only if it's not null
        if (parentTagId !== null) {
            params.parent_tag_id = parentTagId;
        }

        const response = await api.get('/analytics/tag-drill-down', { params });
        return response.data;
    } catch (error) {
        console.error('Error fetching tag drill-down data:', error);
        throw error;
    }
};

// Get complete hierarchical tag data with transaction amounts for all levels
export const getHierarchicalTagData = async (tagType, timeRange) => {
    try {
        const params = {
            tag_type: tagType,
            time_range: JSON.stringify(timeRange),
            include_all_levels: true,
            include_amounts: true
        };

        const response = await api.get('/analytics/tag-hierarchy', { params });
        return response.data;
    } catch (error) {
        console.error('Error fetching hierarchical tag data:', error);
        // Fallback: fetch all levels manually
        return await getTagsByLevels(tagType, timeRange);
    }
};

// Fallback: Get tags by levels manually
const getTagsByLevels = async (tagType, timeRange) => {
    try {
        // Get all tags for this type without parent filter to get complete hierarchy
        const allLevelsData = await getTagDrillDownData(tagType, timeRange, null);
        
        // If the backend doesn't support multi-level in one call, we'll build it
        const levelData = { levels: {}, maxLevel: 0 };
        
        if (allLevelsData.tags) {
            allLevelsData.tags.forEach(tag => {
                const level = tag.level || 0;
                if (!levelData.levels[level]) {
                    levelData.levels[level] = [];
                }
                levelData.levels[level].push(tag);
                levelData.maxLevel = Math.max(levelData.maxLevel, level);
            });
        }
        
        return levelData;
    } catch (error) {
        console.error('Error in fallback tag level fetching:', error);
        return { levels: {}, maxLevel: 0 };
    }
};
